import React from 'react';
import { useIntl } from 'react-intl';
import AIEduButton from '../Button/AIEduButton';

const AIEduDialogFooter = ({
    onConfirm,
    onCancel,
    confirmLabel,
    cancelLabel,
    loading = false,
    className = '',
}) => {
    const intl = useIntl();
    const { formatMessage: f } = intl;

    return (
        <div className={`flex justify-content-end gap-2 ${className}`}>
            <AIEduButton
                label={cancelLabel || f({ id: 'AI_EDU_CANCEL' })}
                onClick={onCancel}
                className='btnSecondary'
                disabled={loading}
            />
            <AIEduButton
                label={confirmLabel || f({ id: 'AI_EDU_CONFIRM' })}
                onClick={onConfirm}
                className='btnPrimary'
                autoFocus
                loading={loading}
            />
        </div>
    );
};

export default AIEduDialogFooter;
